module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABGdBTUEAALGPC/xhBQAAAJ1JREFUOBHlUtsJgDAMbMQxRF1EEAdXwU2Ke9SLtDXSF4hfGgi93h1pEiWVCWMMQZ6tZSIik7GnJRTqkC66tFOpKidC445cSOw4f5YKeWMJfLhQjU/CS2yRsWU2YjcNvOLqIZOaIC4Ao6efgfW1ZXNHpdE22+SAc480fI4W4S8Kj/RIF/2lhOi10X5cSP6BEgfbrgPmTmhcV0sxTsYBmMs59cjCgA4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/upload.png
// module id = NI2G
// module chunks = 1